import React from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';

import * as classes from './RuleTabSidePanel.module.css';

const RuleTabSidePanel = ({
    ...props
}) => {
    const ruleName = { name: 'Nathans Test Rule' };

    return (
        <div className={classes.SidePanel}>
            <div className={classes.RuleContainer}>
                <div className={classes.RuleTitle}>
                    Rule Name
                </div>
                <div className={classes.Rule}>
                    {ruleName.name}
                </div>
            </div>
            <div>
                <div style={{ paddingTop: '1.5rem'}}>
                    <span className={classes.MenuTitle}>
                        Equipments
                    </span>
                    <div className={classes.SubListContainer}>
                        <List className={classes.FormulaList}>
                            <ListItem
                                key={0}
                                classes={{
                                    root: classes.FormulaListItem
                                }}
                            >
                                <Checkbox
                                    value="include"
                                    name="include"
                                    style={{
                                        transform: 'scale(1.5)',
                                        color:     'black'
                                    }}
                                />
                                <span className={classes.Text}>
                                    Select All
                                </span>
                            </ListItem>
                            <ListItem
                                key={1}
                                classes={{
                                    root: classes.FormulaListItem
                                }}
                            >
                                <Checkbox
                                    value="include"
                                    name="include"
                                    style={{
                                        transform: 'scale(1.5)',
                                        color:     'black'
                                    }}
                                />
                                <span className={classes.Text}>
                                    Equipment 1
                                </span>
                            </ListItem>
                            <ListItem
                                key={2}
                                classes={{
                                    root: classes.FormulaListItem
                                }}
                            >
                                <Checkbox
                                    value="include"
                                    name="include"
                                    style={{
                                        transform: 'scale(1.5)',
                                        color:     'black'
                                    }}
                                />
                                <span className={classes.Text}>
                                    Equipment 2
                                </span>
                            </ListItem>
                            <ListItem
                                key={3}
                                classes={{
                                    root: classes.FormulaListItem
                                }}
                            >
                                <Checkbox
                                    value="include"
                                    name="include"
                                    style={{
                                        transform: 'scale(1.5)',
                                        color:     'black'
                                    }}
                                />
                                <span className={classes.Text}>
                                    Equipment 3
                                </span>
                            </ListItem>
                        </List>
                    </div>
                </div>
                <div>
                    <Button
                        className={`${classes.Button}`}
                        data-test-id="confirm"
                        variant="contained"
                    >
                        Select Equipment
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default RuleTabSidePanel;
